import { useEffect, useRef, useState } from "react";

import { styled } from "styled-components";

export const useScrollContainer = (offset: number = 75) => {
  const [scrollContainerTop, setScrollContainerTop] = useState<number>(0);
  const scrollContainer = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    setScrollContainerTop(
      (scrollContainer.current ? scrollContainer.current.offsetTop : 0) +
        offset,
    );
  }, [offset]);

  return { scrollContainerTop, scrollContainer };
};

export const ScrollContainer = styled.div<{ $scrollContainerTop: number }>`
  min-height: ${({ $scrollContainerTop }) =>
    `calc(100vh - ${$scrollContainerTop}px)`};
  max-height: ${({ $scrollContainerTop }) =>
    `calc(100vh - ${$scrollContainerTop}px)`};
  overflow-y: scroll;
  overflow-x: hidden;
  white-space: nowrap;

  &::-webkit-scrollbar {
    width: 0;
  }
`;
